import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {PutJobOnHoldBlockModel} from "@app/workflow-common/services/models/PutJobOnHoldBlockModel";
import {AddJobBlockModel} from "@app/workflow-common/services/models/AddJobBlockModel";
import {CommonService} from "@app/services";

@Component({
  selector: 'app-put-job-hold-widget',
  templateUrl: './put-job-hold-widget.component.html',
  styles: []
})
export class PutJobHoldWidgetComponent implements OnInit {
    @Input() workflowType: string;
    @Input() blockObject;
    @Input() dagSourceModel: DagSourceModel;
    @Input() isConditional:boolean = false;
    @Input() objectName: string;
    @Input() conditionalColName: string = '';
    @Output() close:EventEmitter<{}> = new EventEmitter<{}>();


    form: FormGroup;
    inputModel: PutJobOnHoldBlockModel = undefined;

    changeStageBlockData:{} = {};
    selectedJobDescriptionInputs:{} = {};
    descriptionList: any;
    isLoading: boolean = false;
    isFormSubmitted:boolean = false;


    constructor(
        private formBuilder: FormBuilder,
        private commonService: CommonService
    ) {
    }

    async ngOnInit() {
        this.changeStageBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        const blockObject = {...this.blockObject};
        const modelData = blockObject['model'] ? blockObject['model'] : undefined;
        this.inputModel = new PutJobOnHoldBlockModel(modelData);
        this.makePutOnHoldDropdownData();
        await this.resolveData();
        const formGroupConfig = {
            reasonId: new FormControl(this.inputModel.reasonId, [Validators.required]),
            reasonDisplayName: new FormControl(this.inputModel.reasonDisplayName)
        }
        if(this.isConditional) {
            formGroupConfig['condition'] = this.formBuilder.group({});
        }
        this.form = this.formBuilder.group(formGroupConfig);
    }

    makePutOnHoldDropdownData() {
        this.selectedJobDescriptionInputs['reasonId'] = this.inputModel.reasonId;
        if (this.inputModel.reasonId) {
            this.selectedJobDescriptionInputs['reasonDisplayName'] = this.inputModel.reasonDisplayName;
        }
    }

    async resolveData() {
        this.isLoading = true;
        await this.holdReasonList();
    }
    holdReasonList(){
        return new Promise((resolve) => {
            this.commonService.getJobOnHoldDescription()
                .subscribe(resp => {
                    this.isLoading = false;
                    //console.log(resp);
                    this.descriptionList = resp.map((item) => {
                        return {id: item.Id, text: item.Description}
                    });
                    resolve();
                });
        });
    }
    selectedDescription(event){
        this.form.get('reasonId').setValue(event);
        if(event){
            this.form.get('reasonDisplayName').setValue(this.getDisplayValue(event));
        }
    }
    getDisplayValue(descId){
        const selectedDescription = this.descriptionList.find(x => x.id == descId)
        console.log(selectedDescription);
        return selectedDescription['text'];
    }
    remove(){
        const blockObject = {...this.blockObject};
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    }
    closeModal(){
        this.close.emit({
            action: 'close',
            data: null
        });
    }
    save(){
        this.isFormSubmitted = true;
        const blockObject = {...this.blockObject};
        blockObject.model = new PutJobOnHoldBlockModel(this.form.value);
        const { condition } = this.form.value;

        if(this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        })
    }
}
